import SurveyAnalyticsDashboard from '@/components/surveys/SurveyAnalyticsDashboard';
import SpotSurveyDashboard from '@/components/surveys/SpotSurveyDashboard';
import SurveyFilter from '@/components/surveys/SurveyFilter';

export default [
  {
    path: '/surveys',
    name: 'Surveys',
    meta: { requiresAuth: true, action: 'view', subject: 'surveys' },
    component: SurveyAnalyticsDashboard,
  },
  {
    path: '/surveys/spots',
    name: 'Spot Surveys',
    medta: { requiesAuth: true, action: 'view', subject: 'surveys' },
    component: SpotSurveyDashboard,
  },
  {
    path: '/surveys/filter',
    name: 'Survey Filter',
    media: { requiresAuth: true, action: 'view', subject: 'surveys' },
    component: SurveyFilter,
  },
];



// WEBPACK FOOTER //
// ./src/router/surveys.js